import React from "react";

const ProjectsPagination = ({
  filteredProjects = [],
  projectsPerPage,
  currentPage,
  totalPages,
  pageButtons = [],
  handlePageChange,
}) => {
  if (filteredProjects.length <= projectsPerPage) return null;

  return (
    <div className="pagination-controls d-flex justify-content-center mt-3">
      <button
        className="btn btn-outline-primary mx-1"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        Prev
      </button>

      {pageButtons.map((p, idx) =>
        typeof p === "number" ? (
          <button
            key={idx}
            className={`btn mx-1 ${
              currentPage === p ? "btn-primary" : "btn-outline-primary"
            }`}
            onClick={() => handlePageChange(p)}
          >
            {p}
          </button>
        ) : (
          <button
            key={idx}
            className="btn mx-1 btn-outline-secondary"
            disabled
          >
            …
          </button>
        )
      )}

      <button
        className="btn btn-outline-primary mx-1"
        onClick={() =>
          handlePageChange(Math.min(totalPages, currentPage + 1))
        }
        disabled={currentPage === totalPages}
      >
        Next
      </button>
    </div>
  );
};

export default ProjectsPagination;
